import React from 'react';

import DataModelView from '../../common/view/DataModelView';

export default class ForecastingSummaryView extends DataModelView {
  getIntegratedPropertyNames() {
    return [];
  }

  render() {
    return (<div />);
  }
}